var _excluded = ["value", "max", "readOnly", "onRate", "onMouseOver", "onMouseMove", "onMouseLeave", "theme", "icon"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useState, useRef } from 'react';
import styled, { withTheme } from 'styled-components';
import { number, func, shape, bool } from 'prop-types';
import { StarFilled } from '@gympass/yoga-icons';
import { max as maxPropType } from '../../shared';
var RatingWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n\n  :hover {\n    cursor: pointer;\n  }\n\n  svg {\n    pointer-events: none;\n  }\n\n  ", "\n"])), function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      readOnly = _ref.readOnly;
  return "\n    width: " + width + "px;\n    height: " + height + "px;\n\n    " + (readOnly ? 'pointer-events: none;' : '') + "\n  ";
});
/** Use the Rating component to view other people's opinions and experiences. */

var Rating = function Rating(_ref2) {
  var value = _ref2.value,
      max = _ref2.max,
      readOnly = _ref2.readOnly,
      onRate = _ref2.onRate,
      _onMouseOver = _ref2.onMouseOver,
      _onMouseMove = _ref2.onMouseMove,
      _onMouseLeave = _ref2.onMouseLeave,
      _ref2$theme$yoga = _ref2.theme.yoga,
      colors = _ref2$theme$yoga.colors,
      rating = _ref2$theme$yoga.components.rating,
      _ref2$icon = _ref2.icon,
      _ref2$icon$type = _ref2$icon.type,
      Icon = _ref2$icon$type === void 0 ? StarFilled : _ref2$icon$type,
      _ref2$icon$size = _ref2$icon.size,
      iconSize = _ref2$icon$size === void 0 ? rating.icon.size : _ref2$icon$size,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var wrapperRef = useRef(null);

  var _useState = useState(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useState2 = useState(0),
      currentRating = _useState2[0],
      setCurrentRating = _useState2[1];

  var VIEW_BOX_ICON_SIZE = 12;
  return /*#__PURE__*/React.createElement(RatingWrapper, _extends({
    width: iconSize * max,
    height: iconSize,
    mouseOver: hover,
    readOnly: readOnly
  }, rest, {
    onMouseOver: function onMouseOver(e) {
      setHover(true);

      _onMouseOver(e);
    },
    onMouseMove: function onMouseMove(e) {
      setCurrentRating(Math.ceil((e.clientX - e.target.offsetLeft) / (wrapperRef.current.offsetWidth / max)) || 1);

      _onMouseMove(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      setHover(false);
      setCurrentRating(0);

      _onMouseLeave(e);
    },
    onClick: function onClick() {
      return onRate(currentRating);
    },
    ref: wrapperRef
  }), Array.from({
    length: max
  }, function (_, i) {
    var diff = i + 1 - value;
    var width;

    if (currentRating >= i + 1 || !hover && diff <= 0) {
      // full filled star
      return /*#__PURE__*/React.createElement(Icon, {
        fill: rating.backgroundColor,
        key: "filled-" + i,
        width: iconSize,
        height: iconSize
      });
    }

    if (!hover && diff > 0 && diff < 1) {
      // half filled star
      width = (1 - diff) * iconSize;
      var dWidth = diff * iconSize;
      var wViewBox = VIEW_BOX_ICON_SIZE * (1 - diff);
      var dViewBox = VIEW_BOX_ICON_SIZE * diff;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "half-" + i
      }, /*#__PURE__*/React.createElement(Icon, {
        fill: rating.backgroundColor,
        width: width,
        height: iconSize,
        viewBox: "0 0 " + wViewBox + " " + VIEW_BOX_ICON_SIZE
      }), /*#__PURE__*/React.createElement(Icon, {
        fill: colors.elements.lineAndBorders,
        width: dWidth,
        height: iconSize,
        viewBox: wViewBox + " 0 " + dViewBox + " " + VIEW_BOX_ICON_SIZE
      }));
    }

    return (
      /*#__PURE__*/
      // unfilled star
      React.createElement(Icon, {
        fill: colors.elements.lineAndBorders,
        key: "unfilled-" + i,
        width: iconSize,
        height: iconSize
      })
    );
  }));
};

Rating.propTypes = {
  value: number,

  /** The icon to display */
  icon: shape({
    type: func,
    size: maxPropType(24)
  }),

  /** Maximum rating */
  max: number,

  /** false to make it interactable */
  readOnly: bool,

  /** Event to be fired on click */
  onRate: func,
  onMouseOver: func,
  onMouseMove: func,
  onMouseLeave: func
};
Rating.defaultProps = {
  value: undefined,
  icon: {
    type: StarFilled,
    size: 12
  },
  max: 5,
  readOnly: true,
  onRate: function onRate(rating) {},
  // eslint-disable-line no-unused-vars
  onMouseOver: function onMouseOver() {},
  onMouseMove: function onMouseMove() {},
  onMouseLeave: function onMouseLeave() {}
};
export default withTheme(Rating);